import { WordImageUrlPair } from "../types";
import { createWordService } from "../../../lib";
import { SettingsState } from "../../settings/settingsSlice";

// Use default settings for this utility function
const defaultSettings: SettingsState = {
  maxResults: 10,
  helpLevel: 2,
  selectedVoice: undefined,
  voices: undefined,
  imagesCountLimit: 10,
};

export async function getRandomWordsWithImages(): Promise<WordImageUrlPair[]> {
  const wordService = createWordService.createDefault(defaultSettings);
  return await wordService.getRandomWordImagesPairs();
}
